// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oZVG","clinicsSelect":"styles_clinicsSelect__1BByb"};